import { API_URL } from "../config";
import { COURSE_ALREADY_OWNED_CODE } from "./ownedCourseIds";

/**
 * @param {string[]} courseIds
 * @returns {Promise<{ blocked: boolean, courseIds: string[] }>}
 */
export async function checkCartOwnershipWithBackend(courseIds) {
  const ids = (Array.isArray(courseIds) ? courseIds : [])
    .map((id) => (typeof id === "string" ? id.trim() : ""))
    .filter(Boolean);
  if (ids.length === 0) {
    return { blocked: false, courseIds: [] };
  }

  const response = await fetch(`${API_URL}/api/pedidos/ownership-check`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      items: ids.map((cursoId) => ({ cursoId, qty: 1 })),
    }),
  });

  if (response.status === 409) {
    const data = await response.json().catch(() => ({}));
    if (data?.code === COURSE_ALREADY_OWNED_CODE) {
      const owned = Array.isArray(data.courseIds) ? data.courseIds.map(String) : ids;
      return { blocked: true, courseIds: owned };
    }
  }

  return { blocked: false, courseIds: [] };
}
